import { Flex, SectionTitle } from '@shared/components';
import type { PropsWithChildren } from '@shared/utils';

export type BaseItemSetParagraphSectionProps = PropsWithChildren;

export default function BaseItemSetParagraphSection(
  props: Readonly<BaseItemSetParagraphSectionProps>,
) {
  const { children } = props;
  return (
    <Flex sx={{ flexDirection: 'column', gap: (theme) => theme.spacing(4) }}>
      <SectionTitle title='Paragraph' />
      {children}
    </Flex>
  );
}
